import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShare, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { postData } from '../../../services';
import { useState } from 'react';
import Modal from '../../helpers/Modal';
export const ShareDesignForm = ({ project_id, design_id }) => {
    const { token, base_url } = useAppContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showPricing, setShowPricing] = useState(false);
    const [discount, setDiscount] = useState(0);
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (isSubmitting) return; // Prevent multiple submissions

        // Basic validation
        if (!email.trim()) {
            if (window.showAlert) {
                window.showAlert(400, 'Please enter an email address.');
            }
            return;
        }

        if (discount < 0 || discount > 100) {
            if (window.showAlert) {
                window.showAlert(400, 'Discount percentage must be between 0 and 100.');
            }
            return;
        }

        setIsSubmitting(true);

        try {
            console.log('Submitting design share request');
            const submission = await postData(token, `${base_url}/apis/designs/share-design`, { 
                project_id, 
                design_id, 
                show_pricing: showPricing,
                discount: parseFloat(discount),
                email: email.trim()
            });

            if(submission.msg) { 
                console.log('Design share request processed successfully!');
                if (window.showAlert) {
                    window.showAlert(200, submission.msg);
                }
                // Reset form and close modal on success
                setShowPricing(false);
                setDiscount(0);
                setEmail('');
                setIsModalOpen(false);
            }
        } catch (error) {
            console.error('Error submitting design share request:', error);
            if (window.showAlert) {
                window.showAlert(500, 'Failed to submit design share request. Please try again later.');
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const shareDesignForm = (
        <div>
            <h2>Share Design</h2>
            <p>Share this design with a client or colleague. You can control pricing visibility and apply discounts.</p>
            <hr />

            <div className="company-form-grid">
                <div className="form-group">
                    <label htmlFor="email" className="form-label">
                        Email Address <span className="form-required">*</span>:
                    </label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter recipient's email address"
                        required
                        className="form-input"
                    />
                </div>

                <div className="form-group">
                    <label className="checkbox-label--inline-bold">
                        <input
                            type="checkbox"
                            checked={showPricing}
                            onChange={(e) => setShowPricing(e.target.checked)}
                            className="form-checkbox--scaled"
                        />
                        Show pricing information (MSRP)
                    </label>
                    <small className="form-hint form-hint--indented">
                        If unchecked, pricing details will be hidden from the recipient
                    </small>
                </div>

                <div className="form-group">
                    <label htmlFor="discount" className="form-label">
                        Discount Percentage:
                    </label>
                    <div className="form-input-row">
                        <input
                            type="number"
                            id="discount"
                            name="discount"
                            min="0"
                            max="100"
                            step="0.01"
                            value={discount}
                            onChange={(e) => setDiscount(e.target.value)}
                            placeholder="0"
                            className="form-input form-input--narrow"
                        />
                        <span>%</span>
                    </div>
                    <small className="form-hint">
                        Enter a discount percentage (0-100) to apply to the design pricing
                    </small>
                </div>
            </div>
            
            <div className="form-actions">
                <button
                    type="button"
                    onClick={() => setIsModalOpen(false)}
                    className="btn btn-secondary"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    onClick={handleSubmit}
                    className="btn btn-primary"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? (
                        <>
                            <FontAwesomeIcon icon={faSpinner} spin /> Sharing...
                        </>
                    ) : (
                        'Share Design'
                    )}
                </button>
            </div>
        </div>
    );

    return (
        <>
            <button 
                onClick={() => setIsModalOpen(true)} 
                className="btn btn-secondary btn-action"
                title="Share Design"
            >
                <FontAwesomeIcon icon={faShare} />
                <span>Share</span>
            </button>
            {isModalOpen && (
                <Modal form={shareDesignForm} setIsModalOpen={setIsModalOpen} />
            )}
        </>
    );
};
